import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	ViewEncapsulation,
} from '@angular/core';

interface Ribbon {
	main: string;
	triangle: string;
	text: string;
}

export type RibbonColor = 'yellow' | 'orange' | 'blue' | 'gold';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-ribbon',
	standalone: true,
	templateUrl: './ribbon.html',
})
export class RibbonComponent implements OnChanges {
	@Input() set color(color: RibbonColor) {
		this.mappedColor = this.colorMap[color || 'yellow'];
	}
	@Input() text: string;
	@Input() maxLength = 10;

	ribbonText: string;

	mappedColor: Ribbon;

	colorMap: Record<RibbonColor, Ribbon> = {
		yellow: {
			main: 'bg-yellow-100',
			triangle: 'border-r-yellow-200',
			text: 'text-dark-primary',
		},
		blue: {
			main: 'bg-select-100',
			triangle: 'border-r-select-200',
			text: 'text-white',
		},
		orange: {
			main: 'bg-cta-100',
			triangle: 'border-r-cta-200',
			text: 'text-white',
		},
		gold: {
			main: 'bg-gold-100',
			triangle: 'border-r-gold-200',
			text: 'text-white',
		},
	};

	ngOnChanges(): void {
		this.ribbonText = this.text.slice(0, this.maxLength);
	}
}
